import { parseLCABreakdownFormData } from '@/utils/analysisUtils';
import { aggregateMinorContributors } from '@/utils/miscUtils';
import CostBreakdownChart from '../charts/CostBreakdownChart';
import { getCostsUnit } from '@/utils/pathwayTemplateUtils';
import { useTeaData } from '@/stores/pathwayTemplateAnalysisStore';
import LoadingSkeleton from '../core/LoadingSkeleton';

const DEFAULT_MINOR_THRESHOLD_FRACTION = 0.01;
const MINOR_CONTRIBUTORS_LABEL = 'Minor Contributors';

const TeaBreakdownContainer = () => {
  const { data, loading, error } = useTeaData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const teaResultsBreakdown = parseLCABreakdownFormData(data.feedstock_costs);
  const displayBreakdown = aggregateMinorContributors(teaResultsBreakdown, {
    thresholdFraction: DEFAULT_MINOR_THRESHOLD_FRACTION,
    minorLabel: MINOR_CONTRIBUTORS_LABEL,
  });
  const unit = getCostsUnit(data);

  if (!teaResultsBreakdown) {
    return null;
  }

  return (
    <CostBreakdownChart
      breakdownResults={displayBreakdown}
      yAxisLabel={`Feedstock Breakdown\n[${unit}]`}
      unit={unit}
      variant="doughnut"
    />
  );
};

export default TeaBreakdownContainer;
